import React, { useId, useRef, useState } from "react";
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export default function ConfirmationDialog({ open, title, description, confirmLabel = "Delete", pendingLabel = "Deleting…", onConfirm, onClose, busy = false }) {
  const id = useId();
  const pendingRef = useRef(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const working = busy || pending;
  const confirm = async () => {
    if (busy || pendingRef.current) return;
    pendingRef.current = true;
    setPending(true);
    setError("");
    try { await onConfirm(); }
    catch { setError("Couldn’t complete this action. Please try again."); }
    finally { pendingRef.current = false; setPending(false); }
  };
  return (
    <Dialog open={Boolean(open)} onClose={() => !working && onClose()} disableEscapeKeyDown={working} fullWidth maxWidth="xs"
      aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`}
      PaperProps={{ sx: { borderRadius: "24px", bgcolor: "#fffdf7", border: "1px solid #e2dfcf", p: 1, boxShadow: "0 24px 64px rgba(37,41,32,.2)" } }}>
      <DialogTitle id={`${id}-title`} sx={{ display: "flex", alignItems: "center", gap: 1.5, fontFamily: "Georgia, serif", fontWeight: 700, color: "#252920" }}>
        <Box sx={{ display: "flex", p: 1, bgcolor: "#fbece6", color: "#b94629", borderRadius: "12px" }}><DeleteOutlineIcon /></Box>
        {title}
      </DialogTitle>
      <DialogContent><DialogContentText id={`${id}-description`} sx={{ color: "#747767", lineHeight: 1.7 }}>{description}</DialogContentText>{error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}</DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button autoFocus disabled={working} onClick={onClose} variant="outlined" sx={{ borderRadius: "12px", textTransform: "none", borderColor: "#d9d5c5", color: "#505544" }}>Cancel</Button>
        <Button disabled={working} onClick={confirm} variant="contained" startIcon={working ? <CircularProgress size={16} color="inherit" /> : undefined}
          sx={{ borderRadius: "12px", textTransform: "none", bgcolor: "#b94629", color: "white", boxShadow: "none", "&:hover": { bgcolor: "#96371e" } }}>
          {working ? pendingLabel : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
